(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/redux/actiontypes.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/redux/actiontypes.js');
"use strict";


const INPUT_SET_PERSONAL_GREETING = 'giftform.INPUT_SET_PERSONAL_GREETING';
const INPUT_SET_GREETING = 'giftform.INPUT_SET_GREETING';
const INPUT_SET_NAME = 'giftform.INPUT_SET_NAME';
const INPUT_SET_EMAIL = 'giftform.INPUT_SET_EMAIL';
const INPUT_SET_PHONE = 'giftform.INPUT_SET_PHONE';
const INPUT_SET_RECEIVER_TYPE = 'giftform.INPUT_SET_RECEIVER_TYPE';
const INPUT_SET_DATE = 'giftform.INPUT_SET_DATE';
const INPUT_SET_TIME = 'giftform.INPUT_SET_TIME';
const INPUT_SET_DATE_AND_TIME = 'giftform.INPUT_SET_DATE_AND_TIME';
const INPUT_SET_DATE_TIME_AND_NAME = 'giftform.INPUT_SET_DATE_TIME_AND_NAME';
const SET_DATE_SELECTOR = 'giftform.SET_DATE_SELECTOR';
const FORM_CLEAR = 'giftform.FORM_CLEAR';
svs.tickets_giftshop.gift.giftform.actiontypes = {
  INPUT_SET_PERSONAL_GREETING,
  INPUT_SET_GREETING,
  INPUT_SET_NAME,
  INPUT_SET_EMAIL,
  INPUT_SET_PHONE,
  INPUT_SET_RECEIVER_TYPE,
  INPUT_SET_DATE,
  INPUT_SET_TIME,
  INPUT_SET_DATE_AND_TIME,
  INPUT_SET_DATE_TIME_AND_NAME,
  SET_DATE_SELECTOR,
  FORM_CLEAR
};

 })(window);